import DroppableCategory from './DroppableCategory';

export default DroppableCategory;
